import {LinearProgress, Link as MuiLink} from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import {Link} from "react-router-dom";
import Paper from "@mui/material/Paper";
import * as React from "react";


interface FormWrapperProps {
    title: string;
    onSubmit: React.FormEventHandler<HTMLFormElement>;
    children: React.ReactNode;
    loading?: boolean;
    titleLinkLabel?: string;
    titleLinkTo?: string;
    topPadding?: number;
    sx?: any;
}

export default (props: FormWrapperProps) => {
    const topPadding = props.topPadding !== undefined ? props.topPadding : 16;
    return (
        <Paper sx={{marginTop: topPadding, ...props.sx}}>
            {props.loading &&
                <LinearProgress/>
            }
            {!props.loading &&
                <Box sx={{height: '4px'}}></Box>
            }
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    p: '18px'
                }}
            >
                <Box sx={{textAlign: "left", width: "100%"}}>
                    <Grid container alignItems="center">
                        <Grid item xs>
                            <Typography component="h5" variant='h6' sx={{fontWeight: 400}}>
                                {props.title}
                            </Typography>
                        </Grid>
                        {
                            props.titleLinkTo && props.titleLinkTo && (
                                <Grid item>
                                    <MuiLink component={Link} to={props.titleLinkTo}
                                             style={{fontSize: '.875rem', 'textDecoration': 'none'}}>
                                        {props.titleLinkLabel}
                                    </MuiLink>
                                </Grid>
                            )
                        }
                    </Grid>
                </Box>
                <Box component="form" onSubmit={props.onSubmit} noValidate sx={{mt: 1, width: '100%'}}>
                    {props.children}
                </Box>
            </Box>
        </Paper>
    )
}